import { t } from "../../utils/i18n";
import React from "react";

const Preview = ({
  fees,
  amount,
  netAmount,
  selectedCurrency,
  firstTimeWithdrawalFee,
  isFirstTimeWithdrawal
}) => (
  <div className="preview-wrapper">
    <h4>{t("transfers_send.common.review_details")}</h4>
    <hr />
    <div className="mx-1">
      <div className="row">
        <div className="col-md-5">
          <div className="form-group row d-block ">
            <label className="form-label">
              {t("transfers_send.common.amount")}
              <a
                data-toggle="tooltip"
                className="btn btn-link"
                data-original-title={t("transfers_send.common.tip_subtotal_period")}
              >
                <i className="fa fa-info-circle"></i>
              </a>
            </label>
            <small
              id="netAmountHelpBlock"
              className="form-text text-muted"
            ></small>
          </div>{" "}
        </div>
        <div className="col-md-7">
          <div className="form-group row ">
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text selected-currency border-0">
                  {selectedCurrency}
                </div>
              </div>
              <input
                className="form-control border-0 pr-0"
                placeholder="0.00"
                data-target="cryptoTransfer.outputNetAmount"
                required="required"
                readOnly="readonly"
                type="number"
                value={amount}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-5">
          <div className="form-group row d-block ">
            <label className="form-label">
              {t("transfers_send.common.fee")}
              <a
                data-toggle="tooltip"
                className="btn btn-link"
                data-original-title={t("transfers_send.common.tip_fee")}
              >
                <i className="fa fa-info-circle"></i>
              </a>
            </label>
            <small id="feesHelpBlock" className="form-text text-muted"></small>
          </div>{" "}
        </div>
        <div className="col-md-7">
          <div className="form-group row ">
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text selected-currency border-0">
                  {selectedCurrency}
                </div>
              </div>
              <input
                className="form-control border-0"
                placeholder={t("transfers_send.common.tbd")}
                data-target="cryptoTransfer.outputFeesAmount"
                required="required"
                readOnly="readonly"
                type="number"
                value={parseFloat(fees).toFixed(7)}
              />
            </div>
          </div>{" "}
        </div>
      </div>
      {isFirstTimeWithdrawal && (
        <div className="row">
          <div className="col-md-5">
            <div className="form-group row d-block ">
              <label className="form-label pr-0">
                {t("transfers_send.common.one_time_setup_fee")}
                <a
                  data-toggle="tooltip"
                  className="btn btn-link pl-1 pr-0"
                  data-original-title={t("transfers_send.common.tip_fee")}
                >
                  <i className="fa fa-info-circle"></i>
                </a>
              </label>
              <small
                id="feesHelpBlock"
                className="form-text text-muted"
              ></small>
            </div>{" "}
          </div>
          <div className="col-md-7">
            <div className="form-group row ">
              <div className="input-group mb-2 mr-sm-2">
                <div className="input-group-prepend">
                  <div className="input-group-text selected-currency border-0">
                    {selectedCurrency}
                  </div>
                </div>
                <input
                  className="form-control border-0"
                  placeholder={t("transfers_send.common.tbd")}
                  data-target="cryptoTransfer.outputFeesAmount"
                  required="required"
                  readOnly="readonly"
                  type="number"
                  value={parseFloat(firstTimeWithdrawalFee).toFixed(7)}
                />
              </div>
            </div>{" "}
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-5">
          <div className="form-group row d-block ">
            <label className="form-label">
              {t("transfers_send.common.total")}
              <a
                data-toggle="tooltip"
                className="btn btn-link"
                data-original-title={t("transfers_send.common.tip_fee")}
              >
                <i className="fa fa-info-circle"></i>
              </a>
            </label>
            <small id="feesHelpBlock" className="form-text text-muted"></small>
          </div>{" "}
        </div>
        <div className="col-md-7">
          <div className="form-group row ">
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text selected-currency border-0">
                  {selectedCurrency}
                </div>
              </div>
              <input
                className="form-control border-0"
                placeholder={t("transfers_send.common.tbd")}
                data-target="cryptoTransfer.outputFeesAmount"
                required="required"
                readOnly="readonly"
                type="number"
                value={parseFloat(netAmount).toFixed(7)}
              />
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  </div>
);

export default Preview;
